import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, Fade, IconButton, Modal, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Fragment } from 'react';

import { reasonsForVisitListData } from '@src/components/ReasonForVisit/ReasonForVisit.helpers';

const getModalContainerStyles = (isMobile?: boolean) => ({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	bgcolor: 'background.paper',
	maxWidth: '38.5rem',
	width: isMobile ? 'calc(100% - 6rem)' : '100%',
	p: '0.75rem',
	boxShadow: '0px 15px 12px 0px rgba(0, 0, 0, 0.22), 0px 19px 38px 0px rgba(0, 0, 0, 0.30)',
	borderRadius: '0.5rem',
	height: isMobile ? 'calc(100% - 8rem)' : '50vh',
});

const getModalContentStyles = (isMobile?: boolean) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '0.5rem',
	maxHeight: isMobile ? 'calc(100% - 4rem)' : 'calc(50vh - 4rem)',
	overflow: 'auto',
	px: '1.75rem',
});

const closeButtonStyles = { display: 'flex', justifyContent: 'flex-end' };

export const getModalTitleStyles = (isMobile?: boolean) => ({
	...(isMobile && { fontSize: '1.25rem' }),
});

export default function IllnessExplanationModal({
	open = false,
	handleClose,
}: Readonly<{ open: boolean; handleClose: () => void }>) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			open={open}
			closeAfterTransition
			slots={{ backdrop: Backdrop }}
			slotProps={{
				backdrop: {
					timeout: 500,
				},
			}}
		>
			<Fade in={open}>
				<Box sx={getModalContainerStyles(isMobile)}>
					<Box sx={closeButtonStyles}>
						<IconButton onClick={handleClose}>
							<CloseIcon />
						</IconButton>
					</Box>
					<Box sx={getModalContentStyles(isMobile)}>
						{reasonsForVisitListData.map(({ title, description }) => (
							<Fragment key={title}>
								<Typography variant="header3" sx={getModalTitleStyles(isMobile)}>
									{title}
								</Typography>
								<Typography variant="bodyLargeBook">{description}</Typography>
							</Fragment>
						))}
					</Box>
				</Box>
			</Fade>
		</Modal>
	);
}
